import * as React from "react";
import type { SVGProps } from "react";

const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={21}
    viewBox="0 0 19 21"
    {...props}
  >
    <g fill="none" fillRule="evenodd" transform="rotate(-45 9.427 14.815)">
      <rect
        width={2.349}
        height={22.703}
        x={10.77}
        y={0.593}
        fill="currentColor"
        rx={1.174}
      />
      <rect
        width={22.703}
        height={2.349}
        x={1.788}
        y={9.136}
        fill="#FFF"
        rx={1.174}
      />
      <rect
        width={22.703}
        height={2.349}
        x={0.681}
        y={12.458}
        fill="#FFF"
        rx={1.174}
      />
      <rect
        width={22.703}
        height={2.349}
        x={0.783}
        y={10.96}
        fill="currentColor"
        rx={1.174}
      />
    </g>
  </svg>
);
export default SvgClose;
